module.exports = __webpack_public_path__ + "img/Group 4@2x321.66276b24.png";